import React from "react";
import { observer } from "mobx-react";
import { AuthorPublisherViewStore } from "../../store";
import { AuthorPublisherViewForm } from "./AuthorPublisherViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AuthorPublisherViewProps = {
  authorPublisherViewStore: AuthorPublisherViewStore;
};

export const AuthorPublisherView: React.FC<AuthorPublisherViewProps> = observer(
  ({ authorPublisherViewStore }) => {
    return (
      <div>
        <AuthorPublisherViewForm
          publisherValue={authorPublisherViewStore.publisherValue}
          percentage={authorPublisherViewStore.percentageValue}
          durationInYears={authorPublisherViewStore.durationInYearsValue}
          autoRenewalYears={authorPublisherViewStore.autoRenewalYearsValue}
          onPrint={(handlePrint: () => void) =>
            authorPublisherViewStore.printAuthorPublisher(handlePrint)
          }
          onCancel={() => authorPublisherViewStore.cancelAuthorPublisher()}
          onEdit={
            authorPublisherViewStore.isEditEnabled
              ? () => authorPublisherViewStore.editAuthorPublisher()
              : undefined
          }
        />
        <ErrorDialog
          open={authorPublisherViewStore.errorDialogOpened}
          title={authorPublisherViewStore.errorTitle}
          description={authorPublisherViewStore.errorDescription}
          onClose={() => authorPublisherViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
